import './DashboardPage.scss';
import {
    SaisiesLine,
    TablesLine,
    MembersListLine,
    AppartementsLine,
    CotisationsLine,
    ParametresLine,
    PrestationsSocialesLine,
    PrestationsFinancieresLine,
    CodesLine,
    NouvelAdherentLine,
    NouvelleReservationLine,
    SuiviBilleterieLine,
    TraitementLine
} from '@assets/images/icons';
import { Button, Card, Icon } from '@design-system';
import { DashboardLink } from '@components';
import { useNavigate } from 'react-router-dom';
import { Permission } from '@components/Permission/Permission';

export default function DashboardPage() {
    const navigate = useNavigate();

    return (
        <div className="dashboard-page">
            <div className="dashboard-page-cta">
                <Button
                    variant="outlined"
                    size="large"
                    icon={
                        <Icon variant="surrounded" rounded icon={<NouvelAdherentLine />} size={22} iconInsetSpacing={12} color="sky" />
                    }
                    onClick={() => navigate('/members-management/members/add')}
                >
                    Créer un nouvel adhérent
                </Button>
                <Button
                    variant="outlined"
                    size="large"
                    icon={
                        <Icon
                            variant="surrounded"
                            rounded
                            icon={<NouvelleReservationLine />}
                            size={22}
                            iconInsetSpacing={12}
                            color="sky"
                        />
                    }
                    onClick={() => navigate('/members-management/bookings?action=new')}
                >
                    Créer une réservation
                </Button>
                <Button
                    variant="outlined"
                    size="large"
                    icon={
                        <Icon
                            variant="surrounded"
                            rounded
                            icon={<SuiviBilleterieLine />}
                            size={22}
                            iconInsetSpacing={12}
                            color="turquoise"
                        />
                    }
                    onClick={() => navigate('/members-management/ticketings/add-multi')}
                >
                    Créer une vente billetterie
                </Button>
            </div>

            <div className="dashboard-page-cards">
                <Card headerType="light" headerIcon={<Icon icon={<TablesLine />} size={20} color="secondary" />} headerTitle="Tables">
                    <div className="dashboard-page-cards-links">
                        <DashboardLink color="sky" icon={<MembersListLine />} label="Adhérents" url="/members-management/members" />
                        <DashboardLink
                            color="sky"
                            icon={<AppartementsLine />}
                            label="Logements"
                            url="/members-management/apartments"
                        />
                        <DashboardLink
                            color="sky"
                            icon={<NouvelleReservationLine />}
                            label="Réservations"
                            url="/members-management/bookings"
                        />
                    </div>
                </Card>
                <Card headerType="light" headerIcon={<Icon icon={<SaisiesLine />} size={20} color="secondary" />} headerTitle="Saisies">
                    <div className="dashboard-page-cards-links">
                        <DashboardLink
                            color="turquoise"
                            icon={<SuiviBilleterieLine />}
                            label="Suivi billetterie"
                            url="/members-management/ticketings"
                        />
                        <DashboardLink
                            color="turquoise"
                            icon={<CotisationsLine />}
                            label="Cotisations"
                            url="/members-management/subscriptions"
                        />
                    </div>
                </Card>
                <Card
                    headerType="light"
                    headerIcon={<Icon icon={<TraitementLine />} size={20} color="secondary" />}
                    headerTitle="Traitements"
                >
                    <div className="dashboard-page-cards-links">
                        <Permission role="admin">
                            <DashboardLink
                                color="green-water"
                                icon={<MembersListLine />}
                                label="Édition adhérents"
                                url="/members-management/members/edition"
                            />
                        </Permission>
                        <DashboardLink
                            color="green-water"
                            icon={<AppartementsLine />}
                            label="Planning logements"
                            url="/members-management/apartments/edition"
                        />
                        <DashboardLink
                            color="green-water"
                            icon={<SuiviBilleterieLine />}
                            label="Édition billetterie"
                            url="/members-management/ticketings/edition"
                        />
                        <DashboardLink
                            color="green-water"
                            icon={<CotisationsLine />}
                            label="Édition cotisations"
                            url="/members-management/contributions/edition"
                        />
                        <DashboardLink
                            color="green-water"
                            icon={<PrestationsFinancieresLine />}
                            label="Édition prestations financières"
                            url="/members-management/financial-benefits/edition"
                        />
                        <DashboardLink
                            color="green-water"
                            icon={<PrestationsSocialesLine />}
                            label="Édition prestations sociales"
                            url="/members-management/social-benefits/edition"
                        />
                        <DashboardLink
                            color="green-water"
                            icon={<TraitementLine />}
                            label="Édition étiquettes RTC"
                            url="/members-management/etiquettes/edition"
                        />
                    </div>
                </Card>
                <Permission role="admin">
                    <Card
                        headerType="light"
                        headerIcon={<Icon icon={<ParametresLine />} size={20} color="secondary" />}
                        headerTitle="Paramètres"
                    >
                        <div className="dashboard-page-cards-links">
                            <DashboardLink
                                color="green"
                                icon={<PrestationsFinancieresLine />}
                                label="Prestations financières"
                                url="/members-management/settings/financial-benefits"
                            />
                            <DashboardLink
                                color="green"
                                icon={<PrestationsSocialesLine />}
                                label="Prestations sociales"
                                url="/members-management/settings/social-benefits"
                            />
                            <DashboardLink
                                color="green"
                                icon={<CodesLine />}
                                label="Codes état"
                                url="/members-management/settings/state-codes"
                            />
                            <DashboardLink
                                color="green"
                                icon={<CodesLine />}
                                label="Codes organisation"
                                url="/members-management/settings/organization-codes"
                            />
                            <DashboardLink
                                color="green"
                                icon={<CodesLine />}
                                label="Codes service"
                                url="/members-management/settings/service-codes"
                            />
                            <DashboardLink
                                color="green"
                                icon={<SuiviBilleterieLine />}
                                label="Types de billets"
                                url="/members-management/settings/ticket-types"
                            />
                            <DashboardLink
                                color="green"
                                icon={<ParametresLine />}
                                label="Tarifs appartements"
                                url="/members-management/settings/apartment-prices"
                            />
                            <DashboardLink
                                color="green"
                                icon={<ParametresLine />}
                                label="Utilisateurs"
                                url="/members-management/settings/users"
                            />
                        </div>
                    </Card>
                </Permission>
            </div>
        </div>
    );
}
